import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ISiteBoxDocumentConfig } from '@core/entities/SiteBoxDocumentConfig'

export const useBypassDocumentReview = (
  options?: UseMutationOptions<
    ISiteBoxDocumentConfig,
    RequestErrorType,
    RequestTypes['bypassReview']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...siteBoxDocumentsKeys.bypassReview,
    onSuccess: (data: ISiteBoxDocumentConfig) => {
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byId({ documentId: data.documentId })
          .queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: siteBoxDocumentsKeys.byConfigId._def,
      })
    },
    ...options,
  })
}
